import { Button } from "react-bootstrap";

const FormContact = () => {

    return <div>
        <input type="text" className="form-control mb-3" placeholder="Nombre" />

        {/* <label className="form-control-label">Email</label> */}
        <input type="email" className="form-control mb-3" placeholder="Email" />
        <label className="form-control-label">Comentarios</label>
        <textarea style={{ minHeight: 200 }} className="form-control mb-3" placeholder="Tus comentarios" />
        <Button variant="primary" size="sm" className="w-100">Enviar</Button>
    </div>
}

export default FormContact;